import { DeleteOutlined, DownOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type PorscheMasterDataModuleSpecsFragment } from '../../../../api/fragments/PorscheMasterDataModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';

export type PorscheMasterDataModuleActionsProps = {
    module: PorscheMasterDataModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasDeletePermission'>;
};

const PorscheMasterDataModuleActions = ({ module, permissions }: PorscheMasterDataModuleActionsProps) => {
    const { t } = useTranslation(['porscheMasterDataModuleDetails']);
    const deleteModule = useDeleteModule(module.id);
    const { hasDeletePermission } = permissions;

    const items = [
        hasDeletePermission && {
            label: t('porscheMasterDataModuleDetails:mainActionButtons.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ];

    return (
        <Dropdown overlay={<Menu items={items} />}>
            <Button type="primary">
                <Space>
                    <span>{t('porscheMasterDataModuleDetails:mainActionButtons.actions')}</span>
                    <DownOutlined />
                </Space>
            </Button>
        </Dropdown>
    );
};

export default PorscheMasterDataModuleActions;
